import { DeviceState } from './types/reducerTypes'
import { AnyAction } from 'redux'
import { platformHasAds } from '../../../shared/helpers'

const defaultState: DeviceState = {
  ppid: '',
  latEnabled: false,
  adsEnabled: platformHasAds(),
  deviceModel: 'browser',
  deviceId: '',
  UID: null,
  ttsEnabled: false,
  distributor: '',
  donationQueryParams: '',
}
export default function reducer(state = defaultState, action: AnyAction) {
  switch (action.type) {
    case 'UPDATE_DEVICE':
      return { ...state, ...action.payload }
    case 'UPDATE_DONATION_QUERY_PARAMS':
      return { ...state, donationQueryParams: action.payload }
    default:
      return state
  }
}
